import React, { type FC } from 'react';

import useStore from '@/store';

import useShowUnitsController from './useShowUnitsController';

import {
  Container,
  Content,
  Title,
  Border,
  NumberUnities,
  Text,
  Unitis,
} from './styles';

export const ShowUnits: FC = () => {
  const { establishmentGroup } = useStore();
  const { numberOfEstablishments } = useShowUnitsController(
    `${establishmentGroup?.id}`
  );

  return (
    <Container>
      <Title>Unidades</Title>

      <Content>
        <Border>
          <NumberUnities>{numberOfEstablishments ?? 0}</NumberUnities>
          <Text>unidades cadastradas</Text>
        </Border>
        <Unitis href="/escolha">visualizar unidades</Unitis>
      </Content>
    </Container>
  );
};

export default ShowUnits;
